var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "form",
      {
        attrs: { id: "registrationForm" },
        on: {
          submit: function($event) {
            $event.preventDefault()
          }
        }
      },
      [
        _c("account-registration", {
          attrs: {
            account: _vm.account,
            additionalQuestions: _vm.additionalQuestions,
            crew: _vm.mycrew
          }
        }),
        _vm._v(" "),
        _vm.elementsLoaded
          ? _c("question-list", {
              ref: "questionList",
              attrs: {
                questions: _vm.questionnaire.questionList,
                crew: _vm.mycrew
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("friendly-captcha", {
          attrs: { sitekey: _vm.siteKey },
          on: { done: _vm.frcDone, error: _vm.frcError }
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "errorBox",
          staticStyle: { display: "none" },
          attrs: { id: "errorbox" }
        }),
        _vm._v(" "),
        _c("div", { staticStyle: { "padding-top": "20px" } }, [
          _vm.mycrew == "inStyle"
            ? _c(
                "button",
                {
                  staticClass: "btn btn-white teaserButton",
                  staticStyle: { width: "100%" },
                  on: { click: _vm.saveRegistration }
                },
                [_vm._v("Join now")]
              )
            : _c(
                "button",
                {
                  staticClass: "btn btn-white teaserButton",
                  staticStyle: { width: "100%" },
                  on: { click: _vm.saveRegistration }
                },
                [_vm._v("SPEICHERN")]
              )
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticStyle: { display: "none" },
        attrs: { id: "registrationSuccess" }
      },
      [
        _vm._v(
          "\n\t\tVielen Dank für deine Registrierung. Wir haben dir eine E-Mail an " +
            _vm._s(_vm.account.email) +
            " geschickt. Bitte klicke den darin enthaltenen Link, \n\t\tum deine Registrierung vollständig abzuschließen.\n\t"
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticStyle: { display: "none" },
        attrs: { id: "registrationSuccessInStyle" }
      },
      [
        _c("br"),
        _vm._v(" "),
        _c("br"),
        _vm._v(
          "\n\t\tVielen Dank für die Übermittlung deiner Daten und dein Interesse an der InStyle Crew. Wir haben dir\n\t\teine E-Mail an " +
            _vm._s(_vm.account.email) +
            " gesendet. Bitte klicke auf den darin enthaltenen Link, um deine\n\t\tIdentität zu bestätigen und die Anmeldung abzuschließen\n\t"
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1161f8ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1161f8ae","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Registration.vue
// module id = 251
// module chunks = 2